import keycloak from "../../core/authentication/Keycloak.js";
import {consoleLog} from '../../core/utilities/Utilities.js';
const file='Api.js';

export async function upsertTasks(body){
    let url='/api/upsert_tasks';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    } 
    catch(e){
        consoleLog({file:file,context:'upsertTasks',arg_name:'e',arg_value:e});
    }
}

export async function previewEventTaskImpact(body){
    let url='/api/preview_event_task_impact';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewEventTaskImpact',arg_name:'e',arg_value:e});
    }
}

export async function previewEventExpiration(body){
    let url='/api/preview_event_expiration';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewEventExpiration',arg_name:'e',arg_value:e});
    }
}

export async function previewAccountTaskImpact(body){
    let url='/api/preview_account_task_impact';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewAccountTaskImpact',arg_name:'e',arg_value:e});
    }
}

export async function getActiveTaskInfo(){
    if(!keycloak.authenticated) return null;
    let url='/api/get_active_task_info';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    } 
    catch(e){
        consoleLog({file:file,context:'getActiveTaskInfo',arg_name:'e',arg_value:e});
    }
}

export async function getScheduleByRange(body){
    let responseUI={};
    let url='/api/get_schedule_by_range';
    if(body.params!==undefined&&body.params.length>0){
        for (let param in body.params){
            let paramDelimiter='&';
            if(param==="0"){paramDelimiter='?';}
            url+=paramDelimiter+body.params[param];
        }
    }
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            }
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getScheduleByRange',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getScheduleByRange',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getScheduleByRange: "+e.toString()};
    }
    finally{
        return responseUI
    }
}


export async function generateReport(body){
    let responseUI={};
    let url='/api/generate_report/'+body.reportType;
    if(body.reportParams!==undefined&&body.reportParams.length>0){
        for (let reportParam in body.reportParams){
            let paramDelimiter='&';
            if(reportParam==='0'){paramDelimiter='?';}
            url+=paramDelimiter+body.reportParams[reportParam];
        }
    }
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            }
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'generateReport',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'generateReport',arg_name:'e',arg_value:e});
        responseUI={error:"Error - generateReport: "+e.toString()};
    }
    finally{
        return responseUI
    }
}


export async function getWorkdayStatus(){
    if(!keycloak.authenticated) return null;
    let url='/api/workday/current';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
        });
        const response=await fetchResponse.json();
        if(!fetchResponse.ok){
            return {error:response?.error||`HTTP ${fetchResponse.status}`};
        }
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'getWorkdayStatus',arg_name:'e',arg_value:e});
        return {error:"Error - getWorkdayStatus: "+e.toString()};
    }
}

//action: start|pause|resume|stop - body {category} for start
export async function workdayAction(action,body={}){
    let url='/api/workday/'+action;
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        const response=await fetchResponse.json();
        if(!fetchResponse.ok){
            return {error:response?.error||`HTTP ${fetchResponse.status}`};
        }
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'workdayAction',arg_name:'e',arg_value:e});
        return {error:"Error - workdayAction: "+e.toString()};
    }
}

//Fetches the .xlsx as a blob and triggers a normal browser save
export async function downloadWorkdayExcel(params){
    let url='/api/workday/export?'+params.join('&');
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                Authorization: `Bearer ${keycloak.token}`,
            },
        });
        if(!fetchResponse.ok){
            const response=await fetchResponse.json().catch(()=>({}));
            return {error:response?.error||`HTTP ${fetchResponse.status}`};
        }
        const disposition=fetchResponse.headers.get('Content-Disposition')||'';
        const match=disposition.match(/filename="?([^"]+)"?/);
        const blob=await fetchResponse.blob();
        const link=document.createElement('a');
        link.href=URL.createObjectURL(blob);
        link.download=match?match[1]:'workday.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        return {ok:true};
    }
    catch(e){
        consoleLog({file:file,context:'downloadWorkdayExcel',arg_name:'e',arg_value:e});
        return {error:"Error - downloadWorkdayExcel: "+e.toString()};
    }
}
